import React, { useState, useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';

interface Props { services: any[]; onSelect: (s: any) => void; value?: string; placeholder?: string; }

const ServicePicker: React.FC<Props> = ({ services, onSelect, value, placeholder = 'Search service…' }) => {
  const [q, setQ] = useState('');
  const [open, setOpen] = useState(false);
  const [hi, setHi] = useState(0);
  const [pos, setPos] = useState({ top: 0, left: 0, width: 0 });
  const inputRef = useRef<HTMLInputElement>(null);
  const dropRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const h = (e: MouseEvent) => {
      const t = e.target as Node;
      if (inputRef.current?.contains(t) || dropRef.current?.contains(t)) return;
      setOpen(false);
    };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);

  const place = () => {
    const r = inputRef.current?.getBoundingClientRect();
    if (r) setPos({ top: r.bottom + 2, left: r.left, width: r.width });
  };

  const terms = q.toLowerCase().split(/\s+/).filter(Boolean);
  const list = services.filter((s: any) =>
    terms.every(t => `${s.name} ${s.sku || ''} ${s.category_name || ''}`.toLowerCase().includes(t))
  ).slice(0, 60);

  const pick = (s: any) => { onSelect(s); setQ(''); setOpen(false); inputRef.current?.blur(); };

  return (
    <>
      <input
        ref={inputRef}
        className="form-control"
        placeholder={placeholder}
        value={open ? q : (value || '')}
        onFocus={() => { place(); setOpen(true); setQ(''); setHi(0); }}
        onChange={e => { setQ(e.target.value); setOpen(true); setHi(0); }}
        onKeyDown={e => {
          if (e.key === 'ArrowDown') { e.preventDefault(); setHi(h => Math.min(h + 1, list.length - 1)); }
          else if (e.key === 'ArrowUp') { e.preventDefault(); setHi(h => Math.max(h - 1, 0)); }
          else if (e.key === 'Enter' && list[hi]) { e.preventDefault(); pick(list[hi]); }
          else if (e.key === 'Escape') setOpen(false);
        }}
      />
      {open && ReactDOM.createPortal(
        <div ref={dropRef} style={{ position: 'fixed', top: pos.top, left: pos.left, width: pos.width, zIndex: 9999,
          background: 'var(--sur)', border: '1px solid var(--bdr)', borderRadius: 6, maxHeight: 280, overflowY: 'auto',
          boxShadow: '0 6px 18px rgba(0,0,0,0.15)' }}>
          {list.length === 0
            ? <div style={{ padding: '8px 10px', fontSize: 12, color: 'var(--tx3)' }}>No matching service</div>
            : list.map((s: any, i: number) => (
              <div key={s.id}
                onMouseDown={e => { e.preventDefault(); pick(s); }}
                onMouseEnter={() => setHi(i)}
                style={{ padding: '7px 10px', fontSize: 12, cursor: 'pointer', display: 'flex', justifyContent: 'space-between', gap: 10,
                  background: i === hi ? 'var(--sur2)' : undefined }}>
                <span>{s.name}</span>
                <span style={{ fontFamily: 'monospace', color: 'var(--tx3)' }}>{Number(s.selling_price || 0).toFixed(2)}</span>
              </div>
            ))}
        </div>,
        document.body
      )}
    </>
  );
};

export default ServicePicker;
